/* eslint-disable prefer-rest-params */
import React, { useEffect, useRef, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  LineController,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

import { lineChartOptions } from "./config";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  LineController,
  Title,
  Tooltip,
  Legend
);

const Line = ({ data, shadow = false }) => {
  const chartContainer = useRef(null);
  const [, setChartInstance] = useState(null);

  useEffect(() => {
    if (chartContainer && chartContainer.current) {
      if (shadow) {
        // Register custom controller for line chart with shadow
        class LineWithShadowController extends LineController {
          draw() {
            const { ctx } = this.chart;
            ctx.save();
            ctx.shadowColor = "rgba(0,0,0,0.15)";
            ctx.shadowBlur = 10;
            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = 10;
            super.draw();
            ctx.restore();
          }
        }
        
        LineWithShadowController.id = "lineWithShadow";
        LineWithShadowController.defaults = LineController.defaults;
        
        ChartJS.register(LineWithShadowController);
      }
      
      const context = chartContainer.current.getContext("2d");
      const newChartInstance = new ChartJS(context, {
        type: shadow ? "lineWithShadow" : "line",
        options: lineChartOptions,
        data,
      });
      setChartInstance(newChartInstance);
      
      // Cleanup function to destroy chart instance
      return () => {
        if (newChartInstance) {
          newChartInstance.destroy();
        }
      };
    }
  }, [chartContainer, data, shadow]);

  return <canvas ref={chartContainer} />;
};

export default Line;
